<template>
  <div class="g-content device-list">
    <!-- 搜索 -->
    <div class="device-filter">
      <div class="device-filter-content">
        <a-form-model
          :model="form"
          :rules="rules"
          layout="inline"
          ref="formElement"
          class="device-filter-content-form"
        >
          <div class="device-filter-content-form-left">
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="query">
              <a-input-search
                v-model="form.query"
                :placeholder="$t('device_search_keyword_placeholder')"
                allowClear
                @search="onSearchSubmit"
                class="search-input"
              />
            </a-form-model-item>

            <!-- 客户 -->
            <a-form-model-item
              :label="null"
              prop="customerId"
              v-if="customerList && customerList.length > 1"
            >
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.customerId"
                :placeholder="$t('customer_form_all_customer')"
                show-search
                allowClear
                :filter-option="filterOption"
                @change="customerChange()"
                :autosize="true"
                class="customer-select"
              >
                <a-select-option
                  :value="customer.customerId"
                  v-for="customer in customerList"
                  :key="customer.customerId"
                >
                  {{ customer.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 站点 -->
            <a-form-model-item :label="null" prop="stationId" v-if="form.customerId">
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.stationId"
                :placeholder="$t('device_search_site_placeholder')"
                show-search
                allowClear
                :filter-option="filterOption"
                @change="siteChange"
                :disabled="siteLoading"
                :autosize="true"
                class="station-select"
              >
                <a-select-option
                  :value="site.stationId"
                  v-for="(site, index) in stationList"
                  :key="site.stationId + '_' + index"
                >
                  {{ site.name }}
                </a-select-option>

                <template slot="suffixIcon">
                  <a-icon type="loading" v-if="siteLoading" />
                </template>
              </a-select>
            </a-form-model-item>

            <!-- 设备型号 -->
            <a-form-model-item :label="null" prop="devModelId">
              <a-tree-select
                v-model="form.devModelId"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="modelListTree"
                :placeholder="$t('device_search_model_placeholder')"
                tree-default-expand-all
                :replaceFields="{
                  children: 'children',
                  title: 'name',
                  key: 'devModelId',
                  value: 'devModelId',
                }"
                show-search
                allowClear
                :filter-tree-node="filterTreeNode"
                :searchPlaceholder="$t('device_search_model_search_placeholder')"
                @change="modelChange"
                class="model-select"
              >
              </a-tree-select>
            </a-form-model-item>
          </div>
          <div class="device-filter-btns" style="display: flex;align-items: center;">
            <!-- 提交 -->
            <a-form-model-item>
              <a-button type="primary" @click.prevent="onSearchSubmit">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>

            <!-- 重置 -->
            <a-form-model-item style="margin-right: 0;">
              <a-button @click="onSearchReset">
                {{ $t('com_btn_reset') }}
              </a-button>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>

    <!-- 列表 -->
    <div class="device-list-main">
      <!-- 操作 -->
      <div class="device-list-action">
        <ul class="device-status-tabs">
          <li
            v-for="tab in tabs"
            :key="tab.key"
            @click="changeStatus(tab.key)"
            :class="form.status === tab.key ? 'active' : ''"
          >
            {{ tab.name }}<span>({{ tabsData[tab.dataKey] || 0 }})</span>
          </li>
        </ul>
        <div class="device-btns">
          <div>
            <router-link
              :to="{ name: 'DeviceAdd' }"
              style="margin-right:15px"
              v-if="AUTH_DEVICE_ADD"
            >
              <a-button type="primary" icon="plus">
                {{ $t('com_btn_add_device') }}
              </a-button>
            </router-link>
          </div>
          <div class="device-btns-right">
            <!-- 导出 -->
            <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
              <template slot="title">{{ $t('com_btn_export') }}</template>
              <a-button
                type="primary"
                icon="upload"
                @click="
                  () => {
                    this.exportFileName = this.handleExportName();
                    this.showExport = true;
                  }
                "
                v-if="AUTH_DEVICE_EXPORT"
              >
              </a-button>
            </a-tooltip>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="device-list-content">
        <!-- 加载中 -->
        <Loading :show="loading" v-if="loading" />

        <div v-else>
          <!-- 网络错误 -->
          <NetworkError v-if="networkError" />
          <!-- 内容 -->
          <div v-else class="g-table">
            <a-table
              :columns="columns"
              :data-source="list"
              :pagination="false"
              :rowKey="(text, index) => text.devId"
              bordered
              @change="handleTableChange"
              :loading="tableLoading"
              size="middle"
            >
              <template slot="customStatusTitle">
                <span>{{ $t('device_table_status') }}</span>

                <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                  <template slot="title">
                    <ul>
                      <li v-for="item in $t('device_table_status_info_content')" :key="item.status">
                        <span style="font-weight: normal;">{{ item.status }}:</span>
                        <span style="font-weight: normal;">{{ item.description }}</span>
                      </li>
                    </ul>
                  </template>
                  <a-icon type="question-circle" class="device-status-title-icon" />
                </a-tooltip>
              </template>

              <!-- 名称 -->
              <template slot="Name" slot-scope="text, record">
                <div class="device-list-name">
                  <div class="device-list-name-icon">
                    <DeviceAvatar :avatarType="record.avatar" />
                  </div>
                  <div class="device-list-name-link">
                    <router-link
                      :to="{
                        name: 'DeviceDetail',
                        params: { id: record.devId },
                      }"
                      v-if="AUTH_DEVICE_DETAIL"
                    >
                      <span>{{ text }}</span>
                    </router-link>
                    <span v-else>
                      {{ text }}
                    </span>
                  </div>
                  <!-- <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                    <template slot="title">{{ $t('device_name_copy') }}</template>
                    <a-icon
                      type="copy"
                      data-clipboard-action="copy"
                      title="Copy"
                      style="color:#ccc"
                      :data-clipboard-text="`${text}`"
                      :id="`device_list_copy_${record.id}`"
                      @click="copyContent(`#device_list_copy_${record.id}`)"
                    />
                  </a-tooltip> -->
                </div>
              </template>

              <!-- 状态 -->
              <template slot="Status" slot-scope="text, record">
                <Status
                  :onlineStatus="record.onlineStatus"
                  :faultStatus="record.faultStatus"
                  :workStatus="record.workStatus"
                  :vpnStatus="record.vpnStatus"
                  :disabledStatus="record.disable"
                />
              </template>

              <!-- 维护 -->
              <template slot="maintenanceDay" slot-scope="text, record">
                <!-- 如果值为-1则表示用户未设置 -->
                <span v-if="text && text !== -1" style="cursor: default;">
                  <a-tooltip
                    :title="
                      $t('device_table_maintainace_last_time') +
                        ' : ' +
                        $options.filters.formatDate(record.maintenanceUpdtTime)
                    "
                  >
                    {{ text }}{{ $t('com_time_d') }}
                  </a-tooltip>
                </span>
                <span v-else>--</span>
              </template>

              <!-- 版本 -->
              <template slot="versionInfo" slot-scope="text">
                <div class="g-table-text">
                  {{ text }}
                </div>
              </template>

              <!-- SN -->
              <template slot="devSn" slot-scope="text">
                <div class="g-table-text">
                  {{ text }}
                </div>
              </template>

              <!-- 模型 -->
              <template slot="modelName" slot-scope="text, record">
                <div class="g-table-text">
                  {{
                    record.devModelAliasName ||
                      (modelAliasObject && modelAliasObject[record.devModelId]
                        ? modelAliasObject[record.devModelId]
                        : text)
                  }}
                </div>
              </template>

              <!-- 时间 -->
              <template slot="InstDate" slot-scope="text">
                {{ text | formatDate('yyyy-MM-dd') }}
              </template>

              <template slot="stationName" slot-scope="text">
                <div class="g-table-text">{{ text }}</div>
              </template>

              <!-- 操作 -->
              <template slot="Action" slot-scope="text, record">
                <div class="device-table-action">
                  <!-- 编辑 -->
                  <router-link
                    :to="{
                      name: 'DeviceUpdate',
                      params: { id: record.devId },
                    }"
                    v-if="AUTH_DEVICE_EDIT"
                    class="g-btn-link-icon"
                  >
                    <a-button type="primary">
                      <Icon type="edit" />
                    </a-button>
                  </router-link>

                  <a-popover
                    trigger="hover"
                    placement="bottom"
                    overlayClassName="custom-popover-menu custom-popover-noarrow"
                    v-if="AUTH_DEVICE_DELETE || AUTH_DEVICE_ENABLE_DISABLE"
                  >
                    <template slot="content">
                      <ul class="g-ellipsis-menu">
                        <!-- 已禁用 -->
                        <li
                          @click="enableDeviceBtnClick(record)"
                          v-if="record.disable && AUTH_DEVICE_ENABLE_DISABLE"
                        >
                          <ins><a-icon type="play-circle"/></ins>
                          <span>{{ $t('com_btn_enabled2') }}</span>
                        </li>

                        <!-- 已启用 -->
                        <li
                          @click="disabledDeviceBtnClick(record)"
                          v-if="!record.disable && AUTH_DEVICE_ENABLE_DISABLE"
                        >
                          <ins><Icon type="forbidden2"/></ins>
                          <span>{{ $t('com_btn_disabled2') }}</span>
                        </li>

                        <li
                          @click="deleteDeviceBtnClick(record)"
                          v-if="AUTH_DEVICE_DELETE"
                          style="color:red;"
                        >
                          <ins> <Icon type="delete"/></ins>
                          <span>{{ $t('com_btn_delete') }}</span>
                        </li>
                      </ul>
                    </template>
                    <a-button type="primary" class="ant-btn-ellipsis">
                      <Icon type="ellipsis" />
                    </a-button>
                  </a-popover>
                </div>
              </template>
            </a-table>

            <div class="device-pagination">
              <Pagination
                :current.sync="pagination.current"
                :total="pagination.total"
                :pageSize.sync="pagination.pageSize"
                :callback="pageChange"
                @change="pageChange"
                show-quick-jumper
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 导出弹窗 -->
    <a-modal
      v-model="showExport"
      :title="$t('device_table_export')"
      @ok="handleExport"
      @cancel="() => (showExport = false)"
      centered
      v-if="showExport"
    >
      <p>{{ $t('device_table_export_description') }}</p>
      <a-input :default-value="exportFileName">
        <a-select slot="addonAfter" default-value=".xlsx" v-model="exportFileNameExt">
          <a-select-option value=".xlsx">
            .xlsx
          </a-select-option>
          <!-- <a-select-option value=".pdf">
            .pdf
          </a-select-option> -->
        </a-select>
      </a-input>

      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          size="large"
          @click="handleExport"
          :loading="exportLoading"
        >
          {{ $t('com_btn_export') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { copyContent } from '@/libs/utils';
import * as DeviceAPI from '@/api/device';
import Status from './components/status.vue';
// mixins
import commonMixin from '@/mixins/common';
import cusomterMixin from '@/mixins/customer';
import modelMixin from '@/mixins/model';
import DeviceStatus from '@/mixins/device-status';
import DeviceOperation from '@/mixins/device-operation';
import siteMixin from '@/mixins/site';
import { trim, dragTableToScroll, formatDate, exportExcel } from '@/libs/utils';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { v4 as uuidv4 } from 'uuid';

export default {
  mixins: [
    deviceAuth,
    commonMixin,
    cusomterMixin,
    modelMixin,
    DeviceStatus,
    siteMixin,
    DeviceOperation,
  ],
  components: {
    Status,
  },
  data() {
    return {
      copyContent,
      // 列表类型，为null时，默认全部
      // type: null,
      // 是否有默认站点
      stationId: null,

      filters: this.$options.filters,
      list: null,

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      loading: true,
      tableLoading: false,
      searchLoading: false,
      networkError: false,

      rules: {},
      // 搜索
      form: {
        customerId: undefined,
        stationId: undefined,
        areaId: undefined,
        regionId: undefined,
        devModelId: undefined,
        query: undefined,
        // 默认按创建时间
        orderField: 0,
        orderType: 1,
        status: 0,
      },

      // tab 列表
      // allNum:"所有设备总数",
      // offlineNum:"offline(离线)总数",
      // idleNum:"idle(空闲)总数",
      // workingNum:"working(工作中)总数",
      // faultedNum:"faulted(异常)总数",wq
      // maintainNum:"maintain(维护)总数",
      // firmwareUpdateNum:"firmware update(硬件升级)总数",
      // disableNum:"disable(禁用)总数",
      tabs: [
        {
          key: 0,
          name: this.$t('device_status_all'),
          dataKey: 'allNum',
        },
        {
          key: 1,
          name: this.$t('device_status_offline'),
          dataKey: 'offlineNum',
        },
        {
          key: 2,
          name: this.$t('device_status_idle'),
          dataKey: 'idleNum',
        },
        {
          key: 3,
          name: this.$t('device_status_working'),
          dataKey: 'workingNum',
        },
        {
          key: 4,
          name: this.$t('device_status_faulted'),
          dataKey: 'faultedNum',
        },
        {
          key: 5,
          name: this.$t('device_status_maintain'),
          dataKey: 'maintainNum',
        },
        {
          key: 6,
          name: this.$t('device_status_firewareupdt'),
          dataKey: 'firmwareUpdateNum',
        },
        {
          key: 7,
          name: this.$t('device_status_disabled'),
          dataKey: 'disableNum',
        },
      ],
      tabsData: {},

      // 列表
      columns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },

        {
          title: this.$t('device_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },

        {
          // title: this.$t('device_table_status'),
          dataIndex: 'workStatus',
          scopedSlots: { customRender: 'Status' },
          slots: { title: 'customStatusTitle' },
        },

        {
          title: this.$t('device_table_sn'),
          dataIndex: 'devSn',
          scopedSlots: { customRender: 'devSn' },
        },

        {
          title: this.$t('device_table_model'),
          dataIndex: 'modelName',
          scopedSlots: { customRender: 'modelName' },
        },

        {
          title: this.$t('device_table_soft_version'),
          dataIndex: 'versionInfo',
          scopedSlots: { customRender: 'versionInfo' },
        },

        // 维护（新增）
        {
          title: this.$t('device_table_maintainace'),
          dataIndex: 'maintenanceDay',
          scopedSlots: { customRender: 'maintenanceDay' },
        },

        {
          title: this.$t('device_table_belonged_site'),
          dataIndex: 'stationName',
          scopedSlots: { customRender: 'stationName' },
        },
        {
          title: this.$t('device_table_install_date'),
          dataIndex: 'instDate',
          scopedSlots: { customRender: 'InstDate' },
          sorter: true,
        },
      ],

      selectedRowKeys: [],
      siteLoading: false,
      horizontalScroll: null,

      // 导出
      showExport: false,
      // 导出文件名
      exportFileName: '',
      // 导出文件名后缀
      exportFileNameExt: '.xlsx',
      exportLoading: false,
    };
  },
  created() {
    // 指定某个状态
    let tabType;
    if (this.$route && this.$route.query) {
      // 关键字
      if (this.$route.query.search) {
        this.form.query = this.$route.query.search;
      }

      // tab状态
      if (this.$route.query.status) {
        this.form.status = parseInt(this.$route.query.status, 10);
      }

      // 类型
      if (this.$route.query.type) {
        tabType = this.$route.query.type;
        if (tabType === 'all') {
          this.changeStatus(0, true);
        } else if (tabType === 'offline') {
          this.changeStatus(1, true);
        } else if (tabType === 'faulted') {
          this.changeStatus(4, true);
        }
      }

      // 客户
      if (this.$route.query.customerId) {
        this.form.customerId = this.$route.query.customerId;
        this.customerChange(true);
      }

      // 站点
      if (this.$route.query.siteId) {
        this.form.stationId = this.$route.query.siteId;
        this.stationId = this.$route.query.siteId;
      }

      // 模型
      if (this.$route.query.devModelId) {
        this.form.devModelId = this.$route.query.devModelId;
      }
    }

    // 操作列
    if (this.AUTH_DEVICE_EDIT || this.AUTH_DEVICE_DELETE || this.AUTH_DEVICE_ENABLE_DISABLE) {
      this.columns.push({
        title: this.$t('com_table_action'),
        align: 'center',
        width: 'auto',
        scopedSlots: { customRender: 'Action' },
      });
    }

    this.getData();

    // 获取tab数量
    this.getTabCount();
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    changeStatus(status, noRequest) {
      this.pagination.current = 1;
      this.form.status = status;
      if (!noRequest) {
        this.reloadListPage();
      }
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 获取表单数据
    getData() {
      const _list = [
        this.getAllCustomerList(),
        this.getAllModelList(() => {
          // 如果list已经获取到，则更新list
          //更新 list数据的值，把别名赋值给list
          if (this.list && this.list.length > 0 && Object.keys(this.modelAliasObject).length > 0) {
            this.list.forEach((item, index) => {
              if (this.modelAliasObject[item.devModelId]) {
                const newItem = {
                  ...item,
                  devModelAliasName: this.modelAliasObject[item.devModelId],
                };
                this.$set(this.list, index, newItem);
              }
            });
          }
        }),
        this.getList(true),
      ];
      Promise.all(_list).finally(() => {
        // 当只有一个customer时，默认选中这个customer
        if (this.customerList && this.customerList.length === 1 && !this.form.customerId) {
          this.form.customerId = this.customerList[0].customerId;
          this.customerChange(true);
        }

        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        this.loading = false;

        // 表格横向滚动注册
        this.$nextTick(() => {
          this.horizontalScrollDestory();
          this.horizontalScroll = dragTableToScroll();
        });
      });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    customerChange(noRequest) {
      this.siteLoading = true;
      this.form.stationId = undefined;
      this.getAllSiteList(this.form.customerId).then(_res => {
        this.siteLoading = false;
      });
      if (!noRequest) {
        this.onSearchSubmit();
      }
    },

    modelChange() {
      this.onSearchSubmit();
    },

    // get list
    getList(init) {
      const params = {
        ...this.form,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      // 去掉关键字两边的空格
      if (params.query) {
        params.query = trim(params.query);
        this.form.query = params.query;
      }

      this.pagination.current = params.pageNo;
      if (init) {
        this.loading = true;
      } else {
        this.tableLoading = true;
      }

      // 同时请求tab数量
      this.getTabCount();

      // this.list = [];
      this.networkError = false;
      return DeviceAPI.DeviceList(params)
        .then(res => {
          if (res.code === 0) {
            this.list = res.data || [];

            // 总数
            this.pagination.total = res.totalCount;
          }
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.tableLoading = false;
          this.searchLoading = false;
        });
    },

    handleTableChange(page, filters, sorter) {
      if (sorter && sorter.order) {
        if (sorter.order === 'descend') {
          // 倒序
          this.form.orderField = 1;
          this.form.orderType = 1;
        } else {
          // 正序
          this.form.orderField = 1;
          this.form.orderType = 0;
        }
      } else {
        // 创建时间
        this.form.orderField = 0;
        this.form.orderType = 1;
      }

      this.onSearchSubmit(false);
    },

    siteChange() {
      this.onSearchSubmit();
    },

    // 分页
    pageChange(value) {
      this.pagination.current = value;
      this.getList();
    },

    // 重置表单
    onSearchReset() {
      this.$refs.formElement.resetFields();
      this.form.customerId = undefined;
      this.form.stationId = undefined;
      this.form.devModelId = undefined;
      this.form.query = undefined;
      // tab状态不重置
      // this.form.status = 0;
      this.onSearchSubmit();
    },

    // 提交搜索
    onSearchSubmit(reload = true) {
      this.pagination.current = 1;
      this.searchLoading = true;
      if (reload) {
        this.reloadListPage();
      } else {
        this.getList();
      }
    },

    // 重新跳转页面，在URL记录当前参数
    reloadListPage() {
      this.$router.push({
        key: uuidv4(),
        name: 'DeviceList',
        query: {
          search: this.form.query,
          status: this.form.status,
          customerId: this.form.customerId,
          siteId: this.form.stationId,
          devModelId: this.form.devModelId,
          orderField: this.form.orderField,
          orderType: this.form.orderType,
        },
      });
    },

    // 编辑
    edit() {
      this.$router.push({
        name: 'DeviceUpdate',
        params: {
          id: this.selectedRowKeys[0],
        },
      });
    },

    // webui
    showWebUI(record) {
      this.$refs.webui.show(record);
    },

    // 删除设备
    deleteDeviceBtnClick(currentDevice) {
      this.deleteDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          // 重新获取列表
          this.getList();
        },
      });
    },

    // 禁用设备
    disabledDeviceBtnClick(record) {
      this.disabledDeviceInMixins({
        params: { devId: record.devId },
        devName: record.name,
        callback: () => {
          // 重新获取列表
          this.getList();
        },
      });
    },

    // 启用设备
    enableDeviceBtnClick(currentDevice) {
      this.enableDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          // 重新获取列表
          this.getList();
        },
      });
    },

    // 导出设备
    handleExport() {
      const self = this;

      this.exportLoading = true;
      DeviceAPI.DeviceList({
        ...this.form,
        pageNo: 1,
        pageSize: 20000,
      })
        .then(res => {
          try {
            if (res.code === 0) {
              // 导出来的数据是接口的原始数据，不做处理
              exportExcel(
                { data: res.data || [] }, //单个sheet时传一个对象，多个sheet时传一个数组
                this.exportFileName + this.exportFileNameExt,
                this.exportFileNameExt,
                function() {
                  setTimeout(function() {
                    self.exportLoading = false;
                    self.showExport = false;
                  }, 1000);
                }
              );
            }
          } catch (e) {
            console.error(e);
          }
        })
        .catch(() => {
          this.$message.error(this.$t('device_table_export_message'));
          this.exportLoading = false;
        });
    },

    // 导出的文件名称
    handleExportName() {
      return 'device_list_' + formatDate(new Date(), 'yyyy_MM_dd_HH_mm_ss');
    },

    // 获取tab的数量
    getTabCount() {
      return DeviceAPI.DeviceStatusCount({
        ...this.form,
      }).then(res => {
        if (res && res.code === 0) {
          this.tabsData = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-list {
  // border-radius: 12px;
  // overflow: hidden;
  background: @g-layout-background;
  display: flex;
  flex-direction: column;

  // 搜索
  .device-filter {
    // height: 84px;
    width: 100%;
    display: flex;
    background: @g-layout-background;
    margin-bottom: 16px;

    ::v-deep .device-filter-content {
      height: 100%;
      display: flex;
      padding: 2px 24px 0 24px;
      border-radius: 12px;
      background: #fff;
      align-items: center;
      justify-content: space-between;
      box-sizing: content-box;
      flex: 1;
      margin-bottom: 16px;

      .device-filter-content-form {
        display: flex;
        width: 100%;
        justify-content: space-between;

        .device-filter-content-form-left {
          display: flex;
          align-items: center;
          flex: 1;
          flex-wrap: wrap;
        }
        .device-filter-content-form-right {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }

      /* 隐藏 a-input-search 组件的图标 */
      .ant-input-search-icon {
        display: none;
      }

      .customer-select {
        min-width: 256px;
      }

      .station-select {
        min-width: 256px;
      }

      .model-select {
        min-width: 256px;
      }

      .search-input {
        width: 380px;
      }
    }
  }

  // 内容
  .device-list-main {
    background: #fff;
    padding: 24px 24px 8px 24px;
    border-radius: 12px;
    // outline: @g-layout-background 12px solid;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    display: flex;
    flex: 1;
    flex-direction: column;

    .device-list-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // tabs
      .device-status-tabs {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0 0 16px 0;

        li {
          cursor: pointer;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          margin-right: 24px;
          position: relative;
          span {
            padding: 0 5px;
            font-weight: bold;
          }

          &:hover {
            color: #1838d9;
          }
          &.active {
            color: #1838d9;
            font-weight: 600;

            &::after {
              content: ' ';
              display: block;
              width: 100%;
              height: 3px;
              background: #1838d9;
              position: absolute;
              bottom: -6px;
              left: 0;
            }
          }
        }
      }

      // btns
      .device-btns {
        margin: 0 0 24px 0;
        display: flex;
        justify-content: space-between;

        .device-btns-right {
          display: flex;
          gap: 12px;
        }
      }
    }

    .device-list-content {
      .device-warning-wrapper {
        display: flex;
        flex-wrap: wrap;
        .device-warning {
          height: 22px;
          line-height: 22px;
          padding: 0 4px;
          border-radius: 4px;
          font-size: 12px;
          margin-right: 8px;
          white-space: nowrap;
          margin-bottom: 5px;
          // all
          &.device-warning-all {
            border: 1px solid #e6e7f8;
            background: #f9f9fd;
            color: #1838d9;
          }
          // CA
          &.device-warning-ca {
            color: #f5222d;
            border: 1px solid #ffccc7;
            background: #fff1f0;
          }
          // MA
          &.device-warning-ma {
            color: #faad14;
            border: 1px solid #fff1b8;
            background: #fffbe6;
          }
          // QA
          &.device-warning-qa {
            color: #13c2c2;
            border: 1px solid #b5f5ec;
            background: #e6fffb;
          }
        }
      }

      // action
      .device-table-action {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      dl {
        ul {
          list-style: none;
          display: flex;
          border: #eee solid 1px;
          border-right: none;
          margin: 0;
          padding: 0;
          font-size: 12px;

          li {
            border-right: #eee solid 1px;
            flex: 1;
            padding: 10px 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            span {
              display: flex;
              align-items: center;

              i {
                display: block;
                width: 8px;
                height: 8px;
                border-radius: 100%;
                white-space: nowrap;
                margin-right: 5px;
              }

              em {
                font-style: normal;
              }

              .disabled {
                background: #999;
              }

              .enabled {
                background: #09f175;
              }
            }

            &:nth-child(2) {
              text-align: left;
              align-items: flex-start;
              max-width: 300px;
            }

            &:nth-child(3),
            &:nth-child(4) {
              max-width: 150px;
            }

            &:first-child {
              flex-direction: row;
              justify-content: flex-start;
              max-width: 400px;
            }
            &:last-child {
              flex-direction: row;
              justify-content: flex-start;
            }

            a {
              align-self: center;
              color: #666;
            }

            p {
              width: 100%;
              height: 25px;
              line-height: 25px;
              margin: 0;
            }
          }
        }

        dt {
          ul {
            border-bottom: none;

            li {
              font-weight: normal;
              height: 100%;
              background: #f9f9f9;
            }
          }
        }

        dd {
          ul {
            li {
              &:first-child {
                a {
                  display: flex;
                  word-break: break-all;
                  word-wrap: break-word;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  max-height: 150px;
                  flex-wrap: wrap;
                  align-items: center;

                  img {
                    max-height: 70px;
                    max-width: 100px;
                    margin-right: 15px;
                  }
                }
              }
              &:last-child {
                flex-direction: column;
                justify-content: center;
              }
            }
          }
        }
      }

      // 分页
      .device-pagination {
        justify-content: flex-end;
        display: flex;
        align-items: flex-end;
      }
    }
  }
  .device-list-name {
    display: flex;
    align-items: center;

    .device-list-name-icon {
      margin-right: 4px;
      width: 18px;
      height: 18px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .device-list-name-link {
      flex: 1;
      word-wrap: break-word;
      word-break: break-all;
    }
  }
}

.device-status-title-icon {
  margin-left: 4px;
  cursor: pointer;
  flex: 1;
}
</style>
